import type { ThemeConfig } from "antd";

/**
 * Ant Design 5 theme — Aloja Fácil v3 (Sunset Gradient)
 * Palette derived from brand logo: violet primary, orange accent
 * Poppins headings + DM Sans body
 */
export const antdTheme: ThemeConfig = {
  token: {
    // Brand colors — Violet Sunset
    colorPrimary: "#7C3AED",
    colorSuccess: "#10B981",
    colorWarning: "#F59E0B",
    colorError: "#EF4444",
    colorInfo: "#7C3AED",

    // Typography — Montserrat única (cargada via Google Fonts en variables.css)
    fontFamily:
      '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 14,
    fontSizeHeading1: 32,
    fontSizeHeading2: 26,
    fontSizeHeading3: 20,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,

    // Layout
    borderRadius: 10,
    colorBgLayout: "#FAF5FF",
    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    colorBorder: "#E9D5FF",
    colorBorderSecondary: "#F3E8FF",

    // Text
    colorText: "#1E1B4B",
    colorTextSecondary: "#475569",
    colorTextTertiary: "#64748B",

    // Spacing
    padding: 16,
    paddingLG: 24,
    paddingSM: 12,
    paddingXS: 8,
    margin: 16,
    marginLG: 24,
    marginSM: 12,
    marginXS: 8,

    // Shadows (violet-tinted)
    boxShadow: "0 2px 12px rgba(124, 58, 237, 0.08)",
    boxShadowSecondary: "0 4px 16px rgba(124, 58, 237, 0.10)",

    // Links
    colorLink: "#7C3AED",
    colorLinkHover: "#6D28D9",
    colorLinkActive: "#5B21B6",
  },
  components: {
    Button: {
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 46,
      controlHeightSM: 32,
    },
    Card: {
      borderRadiusLG: 14,
    },
    Table: {
      borderRadius: 10,
      headerBg: "#FAF5FF",
      headerColor: "#1E1B4B",
      rowHoverBg: "#FAF5FF",
    },
    Tabs: {
      itemColor: "#64748B",
      itemSelectedColor: "#7C3AED",
      itemHoverColor: "#6D28D9",
      inkBarColor: "#7C3AED",
    },
    Input: {
      borderRadius: 10,
      controlHeight: 40,
    },
    Select: {
      borderRadius: 10,
      controlHeight: 40,
    },
    Modal: {
      borderRadiusLG: 16,
    },
    Tag: {
      borderRadiusSM: 8,
    },
    Alert: {
      borderRadiusLG: 12,
    },
    DatePicker: {
      borderRadius: 10,
      controlHeight: 40,
    },
  },
};
